import { Counter } from '@/components/ui/counter';

import { content } from './OtherStatusCounter.content';

type OtherStatusesCounterProps = {
  totalNumber: number;
  children: React.ReactNode;
};

export const OtherStatusesCounter = ({ totalNumber, children }: OtherStatusesCounterProps) => {
  if (totalNumber <= 1) {
    return children;
  }

  return (
    <div className="flex items-center gap-4" style={{ anchorScope: 'all' }}>
      <div style={{ anchorName: '--anchor' }}>{children}</div>
      <Counter
        className="h-auto"
        number={totalNumber}
        title={content.tooltip(totalNumber)}
        style={{
          position: 'absolute',
          positionAnchor: '--anchor',
          positionArea: 'bottom right',
          insetInlineStart: 'anchor(90%)',
        }}
      />
    </div>
  );
};
